import { useNavigate, useRouter } from "@tanstack/react-router";

import { Button } from "@/components/button";

import ChevronLeftIcon from "../assets/chevron-left.svg?react";

const REQUEST_TYPE_NAME_MAP = {
  graphic: "Graphic",
  video: "Video",
  webui: "Website & UI",
};

const TAG_CLASS =
  "max-lg:self-start whitespace-nowrap bg-utility-indigo-50 text-utility-indigo-700 border-utility-indigo-200 border rounded-full text-xs font-medium px-sm py-[2px]";

export function Header({
  isAiStudio,
  requestName,
  requestType,
}: {
  isAiStudio?: boolean;
  requestName?: string;
  requestType: keyof typeof REQUEST_TYPE_NAME_MAP;
}) {
  const { history } = useRouter();
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-start gap-xl lg:gap-2xl border-b border-border-secondary px-xl lg:px-3xl pb-2xl pt-xl">
      <Button
        color="gray"
        isIconOnly
        onPress={() =>
          history.canGoBack()
            ? history.go(-1)
            : navigate({ search: { filter: "all" }, to: "/requests" })
        }
        size="lg"
        variant="secondary"
      >
        <ChevronLeftIcon aria-label="Back" />
      </Button>
      <div className="flex flex-col flex-1 min-w-0 gap-xs lg:contents">
        <span className="line-clamp-1 text-display-xs font-semibold text-text-primary">
          {requestName || "Request Name"}
        </span>
        <span className={TAG_CLASS}>
          {REQUEST_TYPE_NAME_MAP[requestType]} Request
        </span>
        {isAiStudio && <span className={TAG_CLASS}>AI Studio</span>}
      </div>
    </div>
  );
}
